import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, firstValueFrom } from 'rxjs';
import { ErrorFrontend } from '@core/errors';
import type { Organization, PaginatedResponse, PaginationParams } from '@core/models';

/**
 * Organization Service — scope-filtered reference data
 * (filter options, tenant drill-down).
 */
@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = 'orgs/organizations';

  /** Organizations in the caller's scope. */
  async list(params?: PaginationParams): Promise<PaginatedResponse<Organization>> {
    return await firstValueFrom(
      this.http
        .get<PaginatedResponse<Organization>>(`${this.baseUrl}/`, {
          params: params as Record<string, string | number>,
        })
        .pipe(
          catchError((error: HttpErrorResponse) => {
            throw new ErrorFrontend(error);
          }),
        ),
    );
  }
}
